import { Select } from "antd";
import React from "react";
import FilterDropdownButtons from "./FilterDropdownButtons";

export const getColumnStaticSelectFilterProps = ({ tableParams, column = {} }) => {
  const { options, ...rest } = column?.filterProps || {};
  const filterColumn = tableParams.filters?.find((item) => item.column === column.dataIndex);
  const filterValue = filterColumn?.value || null;
  return {
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
      <div className="table-filter-dropdown select-filter-dropdown">
        <Select
          variant="outlined"
          getPopupContainer={() => document.body}
          allowClear
          value={selectedKeys}
          onChange={(value) => setSelectedKeys(value)}
          {...rest}
        >
          {options.map((option) => (
            <Select.Option key={option.value} value={option.value}>
              {option.name}
            </Select.Option>
          ))}
        </Select>
        <FilterDropdownButtons confirm={confirm} />
      </div>
    ),
    filteredValue: filterValue
  };
};
